"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = _interopRequireDefault(require("./constants"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var calculationMethodRestrictionsFromGrouping = _constants["default"].calculationMethodRestrictionsFromGrouping,
    sortRestrictionsFromSport = _constants["default"].sortRestrictionsFromSport;

var applyFiltersRestrictions = function applyFiltersRestrictions(_ref) {
  var filters = _ref.filters,
      _ref$hasPointsUnit = _ref.hasPointsUnit,
      hasPointsUnit = _ref$hasPointsUnit === void 0 ? true : _ref$hasPointsUnit;

  var restrictedFilters = _objectSpread({}, filters);

  var grouping = filters.grouping,
      calculationMethod = filters.calculationMethod,
      sport = filters.sport,
      sort = filters.sort;

  if (!calculationMethodRestrictionsFromGrouping[grouping]) {
    restrictedFilters.calculationMethod = 'total';
  }

  if (calculationMethodRestrictionsFromGrouping[grouping] && !calculationMethodRestrictionsFromGrouping[grouping].includes(calculationMethod)) {
    var _calculationMethodRes = (0, _slicedToArray2["default"])(calculationMethodRestrictionsFromGrouping[grouping], 1),
        firstCalculationMethodRestrictionsFromGrouping = _calculationMethodRes[0];

    restrictedFilters.calculationMethod = firstCalculationMethodRestrictionsFromGrouping;
  }

  if (!sortRestrictionsFromSport[sport]) {
    restrictedFilters.sort = hasPointsUnit ? 'points' : 'distance';
  }

  if (sortRestrictionsFromSport[sport] && !sortRestrictionsFromSport[sport].includes(sort)) {
    var _sortRestrictionsFrom = sortRestrictionsFromSport[sport].filter(function (sportRestriction) {
      return hasPointsUnit ? true : sportRestriction !== 'points';
    }),
        _sortRestrictionsFrom2 = (0, _slicedToArray2["default"])(_sortRestrictionsFrom, 1),
        firstSortRestrictionsFromSport = _sortRestrictionsFrom2[0];

    restrictedFilters.sort = firstSortRestrictionsFromSport;
  }

  return restrictedFilters;
};

var _default = applyFiltersRestrictions;
exports["default"] = _default;
//# sourceMappingURL=applyFiltersRestrictions.js.map